export default __webpack_public_path__ + "static/media/sim-azure-1.21ce5dd0.jpg";